import instance from '../../api'

export const getFaqCategories = (search) => instance.get(`/api/admin/faq_categories${search ? `?${search}` : ''}`)

export const createFaqCategories = (fields) => instance.post('/api/admin/faq_categories', fields)

export const updateFaqCategories = (fields, id) => instance.put(`/api/admin/faq_categories/${id}`, fields)

export const deleteFaqCategories = (id) => instance.delete(`/api/admin/faq_categories/${id}`)
